<template>
  <v-autocomplete
    variant="outlined"
    density="compact"
    v-model="inputValue"
    v-bind:items="nations"
    v-bind:item-title="(item) => objectTranslator(item, 'NATION_NAME')"
    v-bind:item-value="(item) => item.NATION_ID"
    v-bind:rules="nationRules"
  ></v-autocomplete>
</template>

<script>
import { objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";

export default {
  name: "NationCard",
  props: {
    modelValue: String,
  },

  data: () => ({
    nationRules: [validator.required],
  }),

  methods: {
    objectTranslator,
  },

  computed: {
    nations: function () {
      return this.$store.state.ref.nations;
    },

    inputValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },

  created() {
    this.$store.dispatch("ref/getNations");
  },
};
</script>
